import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLiveops } from '@/modules/liveops/item/model/mixins';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import { liveopsPointService } from '@/services/liveops';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

export function useLiveopsAdd() {
    const router = useAppRouter();
    const route = useRoute();

    const { model, v$, fetch, decorateRewards } = useLiveops();
    model.rewardType = StringUtils.toNumber(route.query.rewardType);

    const actions = {
        create: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () =>
                liveopsPointService.item.create(
                    model.id, // cloneId
                    model.name,
                    model.rewardType,
                    model.type,
                    model.betCosts,
                    model.startTime.getTime(),
                    model.closeTime.getTime(),
                    model.endTime.getTime(),
                    model.imageFile,
                    model.iconFile
                ),
            onSuccess: ({ data }) =>
                router.push({ name: ROUTE_NAME_LIVEOPS.ITEM.DETAIL(model.rewardType), params: { id: data } })
        })
    };

    onMounted(async () => {
        // for the case: cloning event
        if (model.id) {
            await fetch();
            await decorateRewards();
        }
    });

    return { model, v$, actions };
}
